var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.26 250.26",
    style: {
      enableBackground: "new 0 0 250.26 250.26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.76,218.537h-39.518v-99.071c0-4.143-3.357-7.5-7.5-7.5h-39.557v-39.39c0-4.143-3.357-7.5-7.5-7.5h-47.061 c-4.143,0-7.5,3.357-7.5,7.5v54.07H54.557c-4.143,0-7.5,3.357-7.5,7.5v84.391H15V24.216c0-4.143-3.358-7.5-7.5-7.5 c-4.143,0-7.5,3.357-7.5,7.5v201.82c0,4.143,3.357,7.5,7.5,7.5h46.921c0.046,0.001,0.09,0.007,0.136,0.007h47.061 c0.002,0,0.002,0,0.004,0c0.002,0,0.002,0,0.004,0h47.061h47.057c0.046,0,0.09-0.006,0.136-0.007h46.882c4.143,0,7.5-3.357,7.5-7.5 C250.26,221.894,246.902,218.537,242.76,218.537z M188.242,126.965v91.571h-32.057v-91.571H188.242z M141.186,80.076v39.39v99.071 h-32.061V80.076H141.186z M62.057,141.646h32.061v76.891H62.057V141.646z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statisticsIcon.f132375c5cb118db5f7c8d54669c0019.svg";
export { ForwardRef as ReactComponent };